import { render } from "./Demo.vue?vue&type=template&id=c076681e"
const script = {}
script.render = render

export default script